import PerformanceEvaluationContent from "../components/PerformanceEvaluation/PerformanceEvaluationContent"
import PerformanceEvaluationState from "../context/PerformanceEvaluationContext/PerformanceEvaluationState"


const PerformanceEvaluationScreen = () => {
  return (
    <PerformanceEvaluationState>
      <PerformanceEvaluationContent/>
    </PerformanceEvaluationState>
  )
}

export default PerformanceEvaluationScreen
